import { render } from "./MidrailsAndMullions.vue?vue&type=template&id=b5b4a37e&scoped=true"
import script from "./MidrailsAndMullions.vue?vue&type=script&lang=js"
export * from "./MidrailsAndMullions.vue?vue&type=script&lang=js"

import "./MidrailsAndMullions.vue?vue&type=style&index=0&id=b5b4a37e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b4a37e"]])

export default __exports__